import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"

import "./About.vue?vue&type=style&index=0&id=fa0fe6c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa0fe6c4"]])

export default __exports__